import React from 'react';

interface IconProps {
  color?: string;
}

const FeedbackIcon: React.FC<IconProps> = ({ color = '#00223C' }) => {
  return (
    <svg
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.5 15.7496V14.7897C9.5 13.1633 8.21258 11.8301 6.5836 11.8301H4.1664C2.56369 11.8301 1.25 13.1366 1.25 14.7897V15.7496H9.5Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.40135 10.5229C6.82339 10.5229 7.97619 9.35303 7.97619 7.9099C7.97619 6.46676 6.82339 5.29688 5.40135 5.29688C3.9793 5.29688 2.82651 6.46676 2.82651 7.9099C2.82651 9.35303 3.9793 10.5229 5.40135 10.5229Z"
        stroke={color}
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M17.75 7.35061H12.758L9.50003 9.37703L11.3918 6.01743V1.72461H17.75V7.35061Z"
        stroke={color}
        strokeWidth="2"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default FeedbackIcon;
